import React from 'react';
import {
  CheckCircleIcon,
  DotsHorizontalIcon,
  EyeIcon,
  InformationCircleIcon,
  ShieldExclamationIcon,
  UserRemoveIcon,
  XCircleIcon,
} from '@heroicons/react/solid';
import {
  Button,
  ButtonGroup,
  Card,
  Dropdown,
  FormCheck,
  OverlayTrigger,
  Tooltip,
  Image,
} from 'react-bootstrap';
import { ToggleAction } from './ToggleAction';
import { StorageModule } from '@vlinder-web/storage-module-react';

import * as S from './styles';

const capitalizeFirstLetter = (string: any) =>
  string[0].toUpperCase() + string.slice(1);

const getFirstLetterOfEachWord = (text: any) => {
  try {
    let Rtext = text && text !== '' ? text?.match(/\b\w/g).join('') : '';
    console.log(`Rtext`, Rtext, Rtext.length);
    if (Rtext && Rtext.length > 2) {
      return Rtext.substring(0, 2);
    } else {
      return Rtext;
    }
  } catch (error) {}
};

export const DomainTableRow = (props: any) => {
  const {
    id,
    verified,
    status,
    image,
    firstName,
    lastName,
    middleName,
    name,
    applicationId,
    appliedOn,
    nationality,
    email,
    dateCreated,
    isSelected,
    selectUser,
    deleteUsers,
    onTogglePress,
    onViewDetailClick,
    onViewClick,
    role,
  } = props;
  const VerifiedIcon = verified ? CheckCircleIcon : InformationCircleIcon;
  const storageSrv = StorageModule?.getInstance();
  const userProfile = storageSrv.get('myProfile', 'session');

  const variantColor =
    status === 'Signed by Employer'
      ? '#0000FF'
      : status === 'Ready to Pay'
      ? '#FE8D01'
      : status === 'Application Fees Paid'
      ? '#00AB08'
      : status === 'verified'
      ? '#691783'
      : '#0000FF';

  const statusVariant =
    status === 'active'
      ? 'success'
      : status === 'created'
      ? 'warning'
      : status === 'invited'
      ? 'purple'
      : status === 'verified'
      ? 'purple'
      : status === 'suspended'
      ? 'danger'
      : 'primary';

  const onToggle = (key: string) => {
    if (key === 'view') {
      onViewClick && onViewClick(id);
    } else {
      onTogglePress && onTogglePress(key, applicationId);
    }
  };

  return (
    <tr className="border-bottom user-table">
      <td>
        <FormCheck type="checkbox" className="dashboard-check">
          <FormCheck.Input
            id={`user-${id}`}
            checked={isSelected}
            onChange={() => selectUser(id)}
          />
          <FormCheck.Label htmlFor={`user-${id}`} />
        </FormCheck>
      </td>
      <td>
        <span className="fw-normal">{applicationId}</span>
      </td>
      <td>
        {image || name ? (
          <Card.Link className="d-flex align-items-center">
            {image ? (
              <Image src={image} className="avatar rounded-circle me-3" />
            ) : (
              <div className="avatar d-flex align-items-center justify-content-center fw-bold rounded bg-secondary me-3">
                <span>{getFirstLetterOfEachWord(name)}</span>
              </div>
            )}
            <div className="d-block">
              <span className="fw-normal">{name}</span>
            </div>
          </Card.Link>
        ) : (
          ' - '
        )}
      </td>
      <td>
        <span className="fw-normal">{nationality}</span>
      </td>
      <td>
        <span className="fw-normal">{appliedOn}</span>
      </td>

      <td>
        <span className={`fw-normal `}>
          <S.ButtonComp className={` rounded-pill btn-sm`} color={variantColor}>
            {status}
          </S.ButtonComp>
        </span>
      </td>

      <td>
        <ToggleAction status={status} onTogglePress={onToggle} />
      </td>
    </tr>
  );
};
